import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=0f297a93&scoped=true&lang=html&"
import script from "./TagInput.vue?vue&type=script&lang=js&"
export * from "./TagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f297a93",
  null
  
)

export default component.exports